export default "/react/iDigitalIcon-b8d26f40.svg";